export default __webpack_public_path__ + "static/media/018-antivirus.6b44949f.svg";